<template>
    <v-tab-item :value="thisTab" class="fill-height pa-16">
        <v-layout column justify-center class="h-100 mx-auto" style="max-width: 1224px">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <div class="mb-20 mb-lg-40">
                    <vertical-form-table
                        v-model="form"
                        v-bind="{
                            items,
                            class: 'flex-grow-1',
                        }"
                        @input="emit"
                    >
                        <template #근로계약>
                            <autocomplete-employment-contract
                                v-model="form._contract"
                                v-bind="{
                                    ...attrs_input,
                                    params: params_contract,
                                }"
                                v-if="isOn"
                                @input="emit"
                            />
                        </template>
                    </vertical-form-table>
                </div>
            </v-sheet>
            <div class="v-btn-group flex-wrap mt-16">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('prev')"
                >
                    <v-icon>mdi-chevron-left</v-icon>
                    <span class="grey-6--text"> 이전 단계 </span>
                </v-btn>
                <v-btn
                    color="primary"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        disabled,
                        loading,
                    }"
                    @click="$emit('save')"
                >
                    <span> {{ saveText }} </span>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { attrs_input, initEmploymentForm } from "@/assets/variables";
import { TABS } from "../lib";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import AutocompleteEmploymentContract from "@/components/dumb/autocomplete-employment-contract.vue";
const thisTab = TABS.FORM.value;

const items = [
    {
        key: "_contract",
        term: "근로계약",
        required: true,
    },
];

export default {
    components: {
        VerticalFormTable,
        AutocompleteEmploymentContract,
    },
    props: {
        value: { type: Object, defatul: initEmploymentForm },
        tab: { type: String, default: TABS.SCAN.value },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        saveText: { type: String, default: "출근 하기" },
    },
    data: () => ({
        form: initEmploymentForm(),

        thisTab,
        items,
        attrs_input,
    }),
    computed: {
        isOn() {
            if (!this.shows) return false;
            if (this.tab != thisTab) return false;

            return true;
        },
        params_contract() {
            return {
                _company: this.form._company,
                isSigned: true,
            };
        },
        disabled() {
            return !this.form._contract;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        setLoading(loading) {
            this.$emit("setLoading", loading);
        },
    },
};
</script>

<style></style>
